import React, { Component } from 'react';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { DataHandler, APIHandler, StorageHandler, ContentHeader, Result, BackButton } from 'C4';
import { storageKeys } from 'settings';

export default class Search extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchResults: null,
      appId: -1,
      query: {},
      lastQuery: '',
      searchTimeout: null,
    };
  }

  componentWillMount() {
    DataHandler.matchAppId()
      .then((appId) => {
        StorageHandler.load(storageKeys.lastSearchQuery).then((lastQuery) => {
          if (lastQuery) {
            this.setState({ lastQuery, query: lastQuery, appId }, () => this.getResults());
          } else this.setState({ appId });
        });
      });
  }

  getResults() {
    const { appId, query } = this.state;

    if (query.length > 0 && appId > 0) {
      StorageHandler.save(storageKeys.lastSearchQuery, query);
      APIHandler.getSearchResults(appId, query)
        .then((results) => {
          if (typeof results.hits === 'undefined') {
            // Search has no indexes more, so create a new one
            APIHandler.buildSearchIndex(appId).then(() => {
            });
            return;
          }
          const { hits } = results.hits;
          const searchResults = hits
            .filter(result => result._source.page_type[0] !== 'Final-Page')
            .map((result, i) => {
              const key = i;
              const {
                title,
                image,
                text,
                page_number: page,
              } = result._source;

              return (
                <Result
                  image={image[0]}
                  key={key}
                  text={text}
                  title={title[0]}
                  query={query}
                  url={`/main/ret/chapter/${result._index}/${+page}`}
                />
              );
            });
          if (searchResults !== null && searchResults.length === 0) {
            searchResults[0] = (<p className="subtitle searchSbtl" key={`noRes${0}`}>{i18n.translate('general.noResultsFor', { query })}</p>);
          }
          this.setState({ searchResults });
        });
    }
  }

  updateQuery(e) {
    const { searchTimeout } = this.state;
    const { value } = e.target;
    this.setState({ query: value, searchResults: null });

    if (searchTimeout !== null) {
      clearInterval(searchTimeout);
    }

    const search = setTimeout(() => {
      this.getResults();
    }, 200);
    this.setState({ searchTimeout: search });
  }

  render() {
    const {
      lastQuery,
      searchResults,
      query,
    } = this.state;

    return (
      <div className="contentContainer">
        <ContentHeader
          header={i18n.translate('nav.search')}
          subtitle={i18n.translate('pageDescriptions.search')}
        />
        <div className="search__container">
          <div className="search__input">
            <input
              placeholder={i18n.translate('general.search')}
              onInput={(e) => {
                this.updateQuery(e);
                this.setState({ query: e.target.value });
              }}
              value={typeof query === 'string' ? query : lastQuery}
            />
            <button type="submit" className="searchButton">
              <FontAwesomeIcon icon={['fas', 'search']} />
            </button>
          </div>
          <div className="search__loader">
            {searchResults === null && query.length > 0 && (
              <span>
                <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
              </span>
            )}
          </div>
          <div className="search__result--grid">
            {searchResults}
          </div>
        </div>
      </div>
    );
  }
}
